const MetricBadgeStyle = {
  base: 'inline-block rounded py-0.5 px-2.5 text-[13px] font-medium whitespace-nowrap',
  green: 'bg-green-100 text-green-600',
  yellow: 'bg-yellow-100 text-yellow-600',
  red: 'bg-red-100 text-red-600',
};

export default MetricBadgeStyle;
